import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import AndroidIcon from 'console/images/browsers/android.svg';
import ChromeIcon from 'console/images/browsers/chrome.svg';
import FirefoxIcon from 'console/images/browsers/firefox.svg';
import IEIcon from 'console/images/browsers/ie.svg';
import IosIcon from 'console/images/browsers/ios.svg';
import OperaIcon from 'console/images/browsers/opera.svg';
import SafariIcon from 'console/images/browsers/safari.svg';
import WindowsIcon from 'console/images/browsers/windows.svg';
export var BrowserIcons;
(function (BrowserIcons) {
    BrowserIcons["android"] = "android";
    BrowserIcons["chrome"] = "chrome";
    BrowserIcons["firefox"] = "firefox";
    BrowserIcons["ie"] = "ie";
    BrowserIcons["ios"] = "ios";
    BrowserIcons["opera"] = "opera";
    BrowserIcons["safari"] = "safari";
    BrowserIcons["windows"] = "windows";
})(BrowserIcons || (BrowserIcons = {}));
export function getIcon(icon, props) {
    switch (icon) {
        case BrowserIcons.android:
            return _jsx(AndroidIcon, { ...props });
        case BrowserIcons.chrome:
            return _jsx(ChromeIcon, { ...props });
        case BrowserIcons.firefox:
            return _jsx(FirefoxIcon, { ...props });
        case BrowserIcons.ie:
            return _jsx(IEIcon, { ...props });
        case BrowserIcons.ios:
            return _jsx(IosIcon, { ...props });
        case BrowserIcons.opera:
            return _jsx(OperaIcon, { ...props });
        case BrowserIcons.safari:
            return _jsx(SafariIcon, { ...props });
        case BrowserIcons.windows:
            return _jsx(WindowsIcon, { ...props });
        default:
            return null;
    }
}
function icon_from_user_agent(user_agent) {
    if (user_agent) {
        if (user_agent.search(/Android/) !== -1)
            return BrowserIcons.android;
        else if (user_agent.search(/iPhone|iPad|iPod/) !== -1)
            return BrowserIcons.ios;
        else if (user_agent.search(/Windows Phone/) !== -1)
            return BrowserIcons.windows;
        else if (user_agent.search(/Firefox/) !== -1)
            return BrowserIcons.firefox;
        else if (user_agent.search(/Chrome/) !== -1)
            return BrowserIcons.chrome;
        else if (user_agent.search(/Safari/) !== -1)
            return BrowserIcons.safari;
        else if (user_agent.search(/Opera/) !== -1)
            return BrowserIcons.opera;
        else if (user_agent.search(/MSIE/) !== -1)
            return BrowserIcons.ie;
        else if (user_agent.search(/Trident/) !== -1)
            return BrowserIcons.ie;
    }
    return null;
}
export function parse_login(login) {
    let icon = icon_from_user_agent(login.ua);
    let type_html;
    switch (login.type) {
        case 'web':
            type_html = 'Веб';
            break;
        case 'app':
            type_html = 'Приложение';
            break;
        case 'webui':
            // obsolete type for both web and app
            type_html = 'Веб / Приложение';
            break;
        case 'api':
            // retro app
            type_html = 'Приложение';
            if (login.client.toLowerCase() === 'android')
                icon = BrowserIcons.android;
            else if (login.client.toLowerCase() === 'ios')
                icon = BrowserIcons.ios;
            break;
        default:
            type_html = 'Неизвестно';
    }
    return { icon, type_html };
}
